import React, { useState, useContext, useEffect, useRef } from "react";
import "../../../ui-styles/sliders/RightFullSlider.css";
import "../../../ui-styles/chat/chat.css";
import { LangCtx, InstavcCtx, PayLoadCtx, GroupChatCtx } from "../../../lib/context";
import { loadChat, saveChat } from "../../../actions/chat";
import ChatListItem from "./ChatItems";
// const Cryptr = require('cryptr');
import Loader from "../../../lib/ui/loader/Loader";

const ChatSlide = (props) => {
    const { l } = useContext(LangCtx);
    // const { signaler } = useContext(SignalerCtx);
    // const { instaVC, appointmentData } = props;
    const {chatData} = useContext(GroupChatCtx)
    const { instaVC, appointmentData } = useContext(InstavcCtx);
    const chatBoxRef = useRef(null);
    const { payload } = useContext(PayLoadCtx);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const dataRef = useRef(data);
    const { name, email } = props;
    
    // let name = payload && payload.firstName ? payload.firstName : "";
    // name += payload && payload.lastName ? " " + payload.lastName : "";
    // const email = payload && payload.email ? payload.email : "";

    // const processMessage = useCallback((message) => {
    //     // console.log('Message in chat', message, sender);
    //     // switch (message.messageType) {
    //     //     case 'CMD':
    //     let _msg = message.message;
    //     switch (_msg.message) {
    //         case 'GROUPCHAT':
    //             let _data = [...dataRef.current];
    //             _data.push(_msg.data);
    //             dataRef.current = [..._data];
    //             setData([..._data]);
    //             break;
    //         default: return;
    //     }
    //     //         break;
    //     //     default: return;
    //     // }
    // }, [])

    useEffect(() => {
        getChatData();
        // props.setChatCount(0)
    }, []);

    // useEffect(() => {
    //     console.log("instavc..........:", instaVC)
    //     // instaVC.on('message-received', processMessage);
    //     // return function cleanup() {
    //     //     instaVC.off('message-received');
    //     // }
    // }, [instaVC]);

    // const appendMessage = (mes) => {
    //     console.log("...............:)", mes)
    //     if (mes) {
    //         let _data = [...dataRef.current];
    //         _data.push(mes);
    //         dataRef.current = [..._data];
    //         setData([..._data]);
    //     }
    // }
    

    // useEffect(() => {
    //     signaler.on('RECIEVEMESSAGE', appendMessage)
    
    //   return () => {
    //       signaler.off('RECIEVEMESSAGE');
    //   }
    // }, [signaler])
    

    const getChatData = () => {
        if (appointmentData && appointmentData.appointmentId) {
            setLoading(true);
            loadChat(appointmentData.appointmentId).then(res => {
                setLoading(false);
                if (res && res.data) {
                    dataRef.current = [...res.data];
                    setData([...res.data]);
                }
            }).catch(err => {
                setLoading(false);
                console.log("err ==== ", err);
            });
        }
    }


    useEffect(()=>{
        let lchat = JSON.parse(JSON.stringify(chatData))
        if(lchat?.length > 0 && lchat[lchat.length-1]?.userId !== payload.userId){
            lchat = lchat[lchat.length-1].data
            setData(prevData => [...prevData, lchat]);
        }
    }, [chatData])

    const sendChat = (e) => {
        e.preventDefault();
        let ele = chatBoxRef.current;
        let val = ele.value.trim();
        // const cryptr = new Cryptr(appointmentData.appointmentId);
        if (val !== "") {
            ele.value = "";
            let obj = {
                apptId: appointmentData.appointmentId,
                // message: cryptr.encrypt(val),
                message: val,
                email: payload?.userId ? payload.userId : email,
                name: name,
                messageType: "TXT"
            }

            ele.focus();
            saveChat(obj).then(res => {
                syncCommand("GROUPCHAT", res.data)
                //, obj.apptId);
                setData(prevData => [...prevData,res.data]);
            }).catch(err => {
                console.log("err ==== ", err);
                ele.value = val;
            })
        }
    }

    const syncCommand = (message, body, apptId, cmd = 'CMD') => {
        const _txtCommand = {
            message: message,
            senderName: name,
            senderEmail: email,
            userId: payload && payload.userId ? payload.userId : '',
            messageType: cmd,
            data: body
            // ...body
        }

        // signaler.sendCahtMessage(_txtCommand, apptId);
        instaVC.sendMessageToRoom(_txtCommand);
    }
    return (
        <div className={props.chatSlide ? "chatCntnr fullSlide chatSlideIn" : "chatCntnr fullSlide"}>
            <div className="chatHdr">
                <div className="chatRow">
                    <div className="hdrAvtar">
                        <img src="/images/icons/group-users.png" alt="avtIcon" />
                    </div>
                    <div className="hdrContnet">
                        <span className="hdrTxtL">{l.chat}</span>
                    </div>
                    <div className="hdrAtnGroup">
                        <div className="hdrActn" onClick={props.handleChatSlide}></div>
                    </div>
                </div>
            </div>
            <div className="chatBdy">
                {loading && <Loader />}
                    {data && data.length > 0 ?
                    <div className="chatMsgWrapper">
                        {data.map((item, index) => <ChatListItem key={`${appointmentData.appointmentId}-${index}`} keyId={`${appointmentData.appointmentId}-${index}`} id={appointmentData.appointmentId} sub={payload?.userId ? payload.userId : email} data={item} />)}
                    </div>
                    : null}
            </div>
            <div className="chatFtr">
                <div className="chatRow">
                    <form className="chatForm" onSubmit={sendChat}>
                        <div className="chatMsgInput">
                            <input className="inputMsg" ref={chatBoxRef} name="input" placeholder={l.chat_type} autoComplete="off" autoFocus />
                        </div>
                        <div className="chatSent" onClick={sendChat}>
                            <img src="/images/icons/paper-plane.png" alt="icon" className="invertWhite" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ChatSlide;